import Logger from "../Logger/Logger";
import Translator from "../Translation/Translator";
import Formatter from "../Localization/Formatter";

export interface NormalizedErrorResponseInterface {
  message: string;
  fields: string[];
  translatedMessage: string;
  isAuthenticationIssue: boolean;
  isValidationError: boolean;
  errorId: any;
  blockingCharge: any;
};

class ResponseNormalizer {

  public normalize(err): NormalizedErrorResponseInterface {
    if (typeof err.response === "undefined") {
      Logger.log(err.message);
      if(err.message && document.getElementById('loader-text')) {
        var errorMessageBlock = document.createElement("div");
        errorMessageBlock?.classList.add("error-text-preloader");
        var errorMessageFirstBlock = document.createElement("span");
        var errorMessageSecondBlock = document.createElement("span");
        var errorMessageFirst = document.createTextNode(err.message);
        var errorMessageSecond= document.createTextNode('    Please reload page!');
        errorMessageFirstBlock.appendChild(errorMessageFirst);
        errorMessageSecondBlock.appendChild(errorMessageSecond);
        errorMessageBlock.appendChild(errorMessageFirstBlock);
        errorMessageBlock.appendChild(errorMessageSecondBlock);
        if (!document.getElementsByClassName('error-text-preloader')[0]) {
          document.getElementById('loader-text').appendChild(errorMessageBlock);
        }
      }

      return {
        message: err.message,
        fields: [],
        translatedMessage: Translator.trans("error-response-is-undefined"),
        isAuthenticationIssue: false,
        isValidationError: false,
        errorId: null,
        blockingCharge: null,
      };
    }

    if (typeof err.response.data === "undefined") {
      Logger.log(err.message);
      return {
        message: err.message,
        fields: [],
        translatedMessage: Translator.trans("error-response-contains-no-message"),
        isAuthenticationIssue: false,
        isValidationError: false,
        errorId: null,
        blockingCharge: null,
      };
    }

    Logger.log(err?.response?.data?.error?.defaultMessage);

    return {
      message: err?.response?.data?.error?.defaultMessage,
      fields: err?.response?.data?.error?.fields || [],
      translatedMessage: err?.response?.data?.error?.id === "be_dynamic_error" ?
        err?.response?.data?.error?.defaultMessage 
        :
        err?.response?.data?.error?.errorFieldCounterpartyDisplayName ? Translator.trans(err?.response?.data?.error?.id, {displayName: err?.response?.data?.error?.errorFieldCounterpartyDisplayName})
        :
        Translator.trans(err?.response?.data?.error?.id, 
        // below we can pass different parameters if we need them for translation
        {
          financialStartDate: Formatter.formatDate(err?.response?.data?.error?.financialStartDate)
        }),
      isAuthenticationIssue: err?.response?.status === 401,
      isValidationError: err?.response?.data?.error?.validationError,
      errorId: err?.response?.data?.error?.id,
      blockingCharge: err?.response?.data?.error?.blockingCharge
    };
  }
}

export default new ResponseNormalizer();
